"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("@loadable/component");
const renderApp_1 = __importDefault(require("./renderApp"));
function render() {
    (0, renderApp_1.default)();
}
(0, component_1.loadableReady)(() => {
    render();
});
